$('select[data-action="roofs"]').change(function() {

    var select = $(this);

    var value = select.val();
    var type = $(this).data('type');

    var index = 0;


    var subselect = $('select[name="surface_id"]');
    var other = $('input[name="roof_other"]');
    var sub_other = $('input[name="surface_other"]');

    subselect.find('option').remove().end();

    if(value == 0){
        // show "other" text fields
        other.val("").show();
        sub_other.val("").show();
        subselect.append($('<option>', { text : 'Otros', value : 0, selected : true }));
    }else{
        other.val("").hide();
        sub_other.val("").hide();
        // reset subfields
        select.data('fields').split(/\s*,\s*/).forEach(function(field_name) {
            console.log(field_name);
            $(['name="'+field_name+'"']).val("");
        });
        // reset image (non multiple/inverters type)
        $('.js-'+type+'_image').prop('src','');

        var url = ajax_model_routes[type];

        var option =''
        var jqxhr = $.getJSON(url, {id:value}, function(data) {
            subselect.append($('<option>',{text: "Seleccionar", value: ""}));
            if(data.data.length>0){
                for(var i=0; i<=(data.data.length)-1; i++){
                    var option_data = {};
                    var subfields = data.data[i];
                    $.each(subfields, function( index, value ) {
                        if(index=='name' || index=='name_es'){
                            option_data.text = value;
                        }else if(index=='id'){
                            option_data.value = value;
                        }else{
                            option_data['data-'+index] = value;
                        }
                    });
                    subselect.append($('<option>', option_data));
                }
                option_data = {};
                option_data.text = 'Otros';
                option_data.value = '';
                subselect.append($('<option>', option_data));
            }
        })
        .done(function() {
            //console.log( "second success" );
        })
        .fail(function() {
            console.log( "error" );
        })
        .always(function() {
            console.log( "complete" );
        });
    }

});

$('select[data-action="surfaces"]').change(function() {
    var other = $('input[name="surface_other"]');
    console.log($(this).val());
    if($(this).val() == 0){
        other.val("").show();
    }else{
        other.val("").hide();
    }
});
